const TERMINAL_CONFIG_FIELDS = [
  'nome',
  'len',
  'peel',
  'printOffset',
  'multiLen',
  'multiPeel',
  'multiPrintOffset',
  'minSection',
  'maxSection',
  'allowsMultiple',
  'iconVariant'
];

export const isTerminalConfig = (value) => (
  value !== null &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  TERMINAL_CONFIG_FIELDS.some(field => Object.prototype.hasOwnProperty.call(value, field))
);

export const sanitizeTerminalData = (terminalData) => {
  if (!terminalData || typeof terminalData !== 'object' || Array.isArray(terminalData)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(terminalData).filter(([, terminal]) => isTerminalConfig(terminal))
  );
};
